import { methodResult, post } from "./api.js";
import { labels } from "./config.js";
import { setBusy, showFieldError, showNotice, validateEmail } from "./components.js";
import { handleLoginPayload } from "./session.js";

export function initAppLogin() {
	const entryForm = document.querySelector("[data-auth-login-entry-form]");
	const appForm = document.querySelector("[data-auth-app-login-form]");
	const startButton = entryForm?.querySelector("[data-auth-app-login-start]");
	if (!entryForm || !appForm || !startButton) return;

	const email = entryForm.elements.email;
	const code = appForm.elements.code;
	const backButton = appForm.querySelector("[data-auth-app-login-back]");
	let challenge = null;

	startButton.addEventListener("click", async () => {
		showNotice(entryForm, "");
		const emailError = validateEmail(email);
		if (emailError) {
			showFieldError(email, emailError);
			return;
		}

		setButtonBusy(startButton, true, labels.startingAppLogin);
		try {
			const result = methodResult(
				await post("/api/method/syscofy_core.api.app_login.start", {
					email: email.value.trim(),
				}),
			);
			if (!result?.ok) throw new Error(result?.error?.message || labels.requestFailed);
			challenge = {
				id: result.challenge_id,
				browserToken: result.browser_token,
			};
			entryForm.hidden = true;
			appForm.hidden = false;
			code.focus({ preventScroll: true });
		} catch (error) {
			showNotice(entryForm, error.message || labels.requestFailed);
		} finally {
			setButtonBusy(startButton, false, labels.startingAppLogin);
		}
	});

	code.addEventListener("input", () => {
		code.value = code.value.replace(/\D/g, "").slice(0, 6);
	});

	appForm.addEventListener("submit", async (event) => {
		event.preventDefault();
		showNotice(appForm, "");
		if (!challenge || code.value.length !== 6) {
			showFieldError(code, labels.appCodeRequired);
			return;
		}

		setBusy(appForm, true, labels.verifyingAppLogin);
		try {
			const result = methodResult(
				await post("/api/method/syscofy_core.api.app_login.complete", {
					challenge_id: challenge.id,
					browser_token: challenge.browserToken,
					code: code.value,
				}),
			);
			if (!result?.ok) {
				showNotice(appForm, result?.error?.message || labels.appLoginInvalid);
				return;
			}
			if (!handleLoginPayload(result.session || {})) {
				showNotice(appForm, labels.appLoginInvalid);
			}
		} catch (error) {
			showNotice(
				appForm,
				error.status === 429 ? labels.tooManyRequests : labels.appLoginInvalid,
			);
		} finally {
			setBusy(appForm, false, labels.verifyingAppLogin);
		}
	});

	backButton?.addEventListener("click", () => {
		challenge = null;
		code.value = "";
		showNotice(appForm, "");
		appForm.hidden = true;
		entryForm.hidden = false;
		email.focus({ preventScroll: true });
	});
}

function setButtonBusy(button, busy, busyLabel) {
	if (!button.dataset.idleLabel) button.dataset.idleLabel = button.textContent.trim();
	button.disabled = busy;
	button.setAttribute("aria-busy", String(busy));
	button.textContent = busy ? busyLabel : button.dataset.idleLabel;
}
